import { background, button, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { FCC } from "@/types/common";
import { TabContext, TabList } from "@mui/lab";
import { Box, Tab as MuiTab, styled } from "@mui/material";

export type TTabProps = {
  value: string | number;
  onChange?: ((event: React.SyntheticEvent, value: string | number) => void) | undefined;
  options: { label: string; value: string | number }[];
  selected?: string | number;
};

export const Tab: FCC<TTabProps> = ({ value, onChange, options, children, selected }) => {
  return (
    <BoxTabWrapper>
      <TabContext value={value}>
        <TabList onChange={onChange} variant="fullWidth">
          {options.map((opt, index) => (
            <TabWrapper
              sx={{
                backgroundColor: selected === opt.value ? `${button.primary} !important` : text.disable,
              }}
              key={index}
              label={opt.label}
              value={opt.value}
            />
          ))}
        </TabList>
        {children}
      </TabContext>
    </BoxTabWrapper>
  );
};

const BoxTabWrapper = styled(Box)`
  background-color: ${background.white};
  & .MuiTabs-indicator {
    display: none;
  }

  & .MuiTabs-flexContainer {
    justify-content: space-between;
    gap: 8px;
    border-bottom: 4px solid ${button.primary};

    & .MuiButtonBase-root {
      text-transform: none;
      font-weight: bold;
      font-size: 20px;
      height: 62px;
      color: ${text.white};
      background-color: ${text.disable};
      border-top-right-radius: ${rounded.sm};
      border-top-left-radius: ${rounded.sm};
    }

    & .Mui-selected {
      background-color: ${button.primary};
    }
  }
`;

const TabWrapper = styled(MuiTab)``;
